import { createFeatureSelector, createSelector } from '@ngrx/store';
import { DeviceRegisterState, deviceRegisterFeatureKey } from './device-register.reducer';

const deviceRegisterSelector = createFeatureSelector<DeviceRegisterState>(deviceRegisterFeatureKey);

export const selectFilters = createSelector(deviceRegisterSelector, (state) => {
   return state.filters;
});

export const selectIsOnSystemPage = createSelector(deviceRegisterSelector, (state) => {
   return state.isOnSystemPage;
});
